'use client';
import React from 'react';
import Footer from './footer/Footer';
import NavBar from './navbar/NavBar';
import { usePathname } from 'next/navigation';

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const pathname = usePathname();
  const hideNavbarRoutes = ['/schedule-a-call', '/blog-admin'];
  // const shouldHideNavbar = hideNavbarRoutes.includes(pathname);
  const shouldHideNavbar = hideNavbarRoutes.some((route) =>
    pathname.includes(route),
  );
  return (
    <>
      {!shouldHideNavbar && <NavBar />}
      <main>{children}</main>
      {!shouldHideNavbar && <Footer />}
    </>
  );
};
export default Layout;
